import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const DragIcon = ({ ...props }: IconProps) => (
  <Icon
    w={6}
    h={6}
    fill="gray.500"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.49999 3.83333C8.41999 3.83333 9.16666 3.08667 9.16666 2.16667C9.16666 1.24667 8.41999 0.5 7.49999 0.5C6.57999 0.5 5.83333 1.24667 5.83333 2.16667C5.83333 3.08667 6.57999 3.83333 7.49999 3.83333ZM7.49999 6.33333C6.57999 6.33333 5.83333 7.08 5.83333 8C5.83333 8.92 6.57999 9.66667 7.49999 9.66667C8.41999 9.66667 9.16666 8.92 9.16666 8C9.16666 7.08 8.41999 6.33333 7.49999 6.33333ZM5.83333 13.8333C5.83333 12.9133 6.57999 12.1667 7.49999 12.1667C8.41999 12.1667 9.16666 12.9133 9.16666 13.8333C9.16666 14.7533 8.41999 15.5 7.49999 15.5C6.57999 15.5 5.83333 14.7533 5.83333 13.8333Z"
    />
    
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 3.83333C3.42 3.83333 4.16666 3.08667 4.16666 2.16667C4.16666 1.24667 3.42 0.5 2.5 0.5C1.58 0.5 0.833328 1.24667 0.833328 2.16667C0.833328 3.08667 1.58 3.83333 2.5 3.83333ZM2.5 6.33333C1.58 6.33333 0.833328 7.08 0.833328 8C0.833328 8.92 1.58 9.66667 2.5 9.66667C3.42 9.66667 4.16666 8.92 4.16666 8C4.16666 7.08 3.42 6.33333 2.5 6.33333ZM0.833328 13.8333C0.833328 12.9133 1.58 12.1667 2.5 12.1667C3.42 12.1667 4.16666 12.9133 4.16666 13.8333C4.16666 14.7533 3.42 15.5 2.5 15.5C1.58 15.5 0.833328 14.7533 0.833328 13.8333Z"
    />
  </Icon>
);

export default DragIcon;
